import React from 'react';
import PropTypes from 'prop-types';
import BackgroundColor from '~/client/components/background-color/background-color';

import { stringSelectSpec, boolCheckboxSpec } from '../../lib/editing-configs';

import './divider.less';

const Divider = ({ borderColor, bgOptions, borderWidth, fullWidthMobile }) => {
  const dividerClassName = fullWidthMobile
    ? 'standard-divider__cont--100'
    : 'standard-divider__cont';
  let backgroundOptions = bgOptions;
  if (!bgOptions && borderColor) {
    backgroundOptions = { backgroundColor: borderColor };
  }
  return (
    <BackgroundColor bgOptions={backgroundOptions}>
      {(backgroundColor) => (
        <div className={`${dividerClassName}`}>
          <div
            className="standard-divider"
            style={{
              borderTop: `${borderWidth} solid ${backgroundColor}`,
            }}
          />
        </div>
      )}
    </BackgroundColor>
  );
};

Divider.propTypes = {
  borderColor: PropTypes.string,
  borderWidth: PropTypes.string,
  fullWidthMobile: PropTypes.bool,
  bgOptions: PropTypes.object,
};

Divider.defaultProps = {
  borderColor: 'charcoal',
  borderWidth: '1px',
  fullWidthMobile: false,
};

const getBgColorConfig = (componentDocument) =>
  BackgroundColor.getEditingConfig(componentDocument).map((item) => {
    if (item.fieldName === 'bgOptions.backgroundColor') {
      return {
        ...item,
        fieldLabel: 'Color',
      };
    }
    if (item.fieldName === 'bgOptions.hexColor') {
      return {
        ...item,
        fieldLabel: 'Hex color override',
      };
    }
    return item;
  });

Divider.getEditingConfig = (componentDocument) => [
  ...getBgColorConfig(componentDocument),
  stringSelectSpec(
    'borderWidth',
    'Height of divider (in pixels)',
    [
      { label: '1px', value: '1px' },
      { label: '2px', value: '2px' },
      { label: '3px', value: '3px' },
      { label: '4px', value: '4px' },
    ],
    {
      help: 'Select a divider height between 1px and 4px',
    }
  ),
  boolCheckboxSpec(
    'fullWidthMobile',
    '100% width in mobile and desktop viewports?',
    {
      help: 'The Divider defaults to a width of 280px on mobile viewports. Check this box to make it 100% width for mobile and desktop viewports instead.',
    }
  ),
];

Divider.displayName = 'Divider';

export default Divider;
